import { useState, useCallback } from 'react'

import useToast from '~/src/components/generic/Toast/hook/useToast'

import useTranslation from '~/src/hooks/useTranslation'

import { RequestStatus } from '~/src/components/ReportIssue/types'

type TrainingRequestState = {
  isLoading: boolean
  status: RequestStatus
}

type UseTrainingRequestReturnType = [
  submitTrainingRequest: (details: string, onSuccess?: () => void) => void,
  state: TrainingRequestState
]

const useTrainingRequest = (): UseTrainingRequestReturnType => {
  const [isLoading, setIsLoading] = useState(false)
  const [status, setStatus] = useState<RequestStatus>(null)

  const toast = useToast()
  const { t } = useTranslation('common')

  const submitTrainingRequest = useCallback(
    async (details: string, onSuccess?: () => void) => {
      setIsLoading(true)
      setStatus(null)

      try {
        const response = await fetch(
          `${process.env.NEXT_PUBLIC_REST_URL}/feedback/training-request`,
          {
            method: 'POST',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ details }),
          }
        )

        if (response.ok) {
          setStatus('success')
          toast.success(t('trainingRequest.submitted'), {
            id: new Date().valueOf(),
          })
          onSuccess?.()
        } else {
          setStatus('error')
        }
      } catch (error) {
        setStatus('error')
      }

      setIsLoading(false)
    },
    [toast, t]
  )

  return [submitTrainingRequest, { isLoading, status }]
}

export default useTrainingRequest
